import { toAbsoluteUrl } from "../../../../_theme/helpers";
import { envConfig } from "../../../../utils/config";

const BackgroundVideo: React.FC = () => (
    <video
        src={`${envConfig.APP_MEDIA_URL}videos/public-pages/home-bg.mp4`}
        muted
        autoPlay
        loop
        playsInline
        className="position-fixed top-0 start-0 w-100 h-100 object-fit-cover"
        style={{ zIndex: 0 }}
    />
);

export { BackgroundVideo };